import { memo } from 'react';

import { LayoutGridIcon, Link2Icon } from '@air/design-icons';

import { type WorkspaceAgentShareLinkMonikerPreviewMedia } from '~/components/v2/components/workspace/workspace-agent-panel/utils/workspaceAgentShareLinkMonikerPreviewMedia';

export type WorkspaceAgentShareLinkPillLeadingVisualProps = {
  previewMedia: WorkspaceAgentShareLinkMonikerPreviewMedia | null;
};

/**
 * Link mark for every share-link chip, inset so the chip border stays one rounded rectangle.
 * A board link adds the layout-grid mark. The chip never uses a still.
 */
export const WorkspaceAgentShareLinkPillLeadingVisual = memo(
  ({ previewMedia }: WorkspaceAgentShareLinkPillLeadingVisualProps) => (
    <>
      {/* 18px: one pixel inside the 20px chip, matching the prototype's link box. */}
      <span
        className="flex size-[18px] shrink-0 items-center justify-center rounded-2 ads:bg-subtle bg-gray-3 ads:text-icon-default text-gray-11"
        data-testid="WORKSPACE_AGENT_MESSAGE_SHARE_LINK_PILL_LEADING"
      >
        <Link2Icon aria-hidden data-testid="WORKSPACE_AGENT_MESSAGE_SHARE_LINK_PILL_ICON" size="xs" />
      </span>
      {previewMedia?.kind === 'board' ? (
        <LayoutGridIcon
          aria-hidden
          className="shrink-0 ads:text-icon-default text-gray-11"
          data-testid="WORKSPACE_AGENT_MESSAGE_SHARE_LINK_PILL_BOARD_ICON"
          size="xs"
        />
      ) : null}
    </>
  ),
);

WorkspaceAgentShareLinkPillLeadingVisual.displayName = 'WorkspaceAgentShareLinkPillLeadingVisual';
